<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Offers"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                    <app-button element="button" @click="$router.push({ name: 'offers.new' })" class="btn btn--primary btn--primary--sml" v-if="checkPermission('offers', 'create')">New Offer</app-button>
                </div>
            </div>

            <app-box :loading="loading" :initial="loading" v-if="checkPermission('offers', 'view')">
                <div class="flex flex-wrap -mx-2">
                    <div class="flex w-full px-2">
                        <app-field-text
                            v-model="search"
                            placeholder="Search Offers"
                            class="w-full mr-4"
                            @input="searchOffers"
                        />
                        <app-button
                            element="button"
                            @click="resetSearch"
                            :class="['flex whitespace-no-wrap items-center align-center btn btn--primary btn--primary--sml mb-5']"
                        >
                            Reset Search
                        </app-button>
                    </div>
                </div>

                <strong class="block mb-4">Publishable:</strong>
                <app-table v-if="offers.length > 0">
                    <app-table-header>
                        <app-table-row :header="true">
                            <app-table-cell :header="true">
                                Title
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Languages
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Published
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Published At
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true" />
                        </app-table-row>
                    </app-table-header>

                    <app-table-body>
                        <app-table-row v-for="(o, i) in offers" :key="i">
                            <app-table-cell>
                                {{ o.title }}

                                <router-link :to="{ name: 'offers.drafts.home', params: { id: o.id } }" v-if="o.drafts.length > 0 && checkPermission('offers', 'publishable')" class="mt-2 text-grey block text-xs">
                                    <span v-html="o.drafts.length" class="font-bold"></span> awaiting draft(s)
                                </router-link>
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                <div v-for="(locale, key) in locales" :key="key" v-tooltip="locale.lang" class="inline-block mr-3">
                                    <router-link :to="{ name: 'offers.new.child', params: { id: o.id } }" v-if="o.locale.flag != locale.flag && !isTranslated(o, locale)">
                                        <img :src="require(`../../assets/img/flags/${locale.flag}.png`)" style="width: 30px; height: 18px;" class="rounded-lg opacity-25"  />
                                    </router-link>
                                    <router-link v-else :to="{ name: 'offers.edit', params: { id: getId(o, locale), page: $route.query.page ? $route.query.page : 1, search: $route.query.search ? $route.query.search : '' } }">
                                        <img :src="require(`../../assets/img/flags/${locale.flag}.png`)" class="rounded-lg" style="width: 30px; height: 18px;"  />
                                    </router-link>
                                </div>
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                <app-icon :icon="o.published ? 'check-circle' : 'times-circle'" :class="{'text-green': o.published, 'text-red': !o.published, 'text-lg': true}" />
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                {{ moment(o.published_at).format('D MMM YY') }}
                                <span class="text-xs block mt-1 text-grey">({{ moment(o.published_at).fromNow() }})</span>
                            </app-table-cell>
                            <app-table-cell>
                                <router-link :to="{ name: 'offers.edit', params: { id: o.id, page: $route.query.page ? $route.query.page : 1, search: $route.query.search ? $route.query.search : '' } }" class="mr-2 text-blue hover:text-blue-darker"  v-if="checkPermission('offers', 'edit') && o.children.length < 1">
                                    <app-icon icon="edit" />
                                </router-link>
                                <app-icon icon="trash" class="text-red cursor-pointer" @click="confirmModalOpened = true; confirmModalId = o.id" v-if="checkPermission('offers', 'delete')" />
                            </app-table-cell>
                        </app-table-row>
                    </app-table-body>
                </app-table>

                <app-pagination-links
                    :response="response"
                    :resources="offers"
                    @next="selectNextPage"
                    @previous="selectPreviousPage"
                />
            </app-box>

            <app-box :loading="loading" :initial="loading" class="mt-8" v-if="drafts.length > 0 && checkPermission('offers', 'view') && checkPermission('offers', 'publishable')">
                <strong class="block mb-4">Drafted:</strong>
                <app-table>
                    <app-table-header>
                        <app-table-row :header="true">
                            <app-table-cell :header="true">
                                Title
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Languages
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true" />
                        </app-table-row>
                    </app-table-header>

                    <app-table-body>
                        <app-table-row v-for="(d, i) in drafts" :key="i">
                            <app-table-cell>
                                {{ d.title }}
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                <div v-for="(locale, key) in locales" :key="key" v-tooltip="locale.lang" class="inline-block mr-3">
                                    <span v-if="d.locale.flag != locale.flag">
                                        <img :src="require(`../../assets/img/flags/${locale.flag}.png`)" style="width: 30px; height: 18px;" class="rounded-lg opacity-25"  />
                                    </span>
                                    <span v-else>
                                        <img :src="require(`../../assets/img/flags/${locale.flag}.png`)" class="rounded-lg" style="width: 30px; height: 18px;"  />
                                    </span>
                                </div>
                            </app-table-cell>
                            <app-table-cell>
                                <router-link :to="{ name: 'offers.view', params: { id: d.id } }" class="mr-2 text-blue hover:text-blue-darker" v-if="checkPermission('offers', 'edit')">
                                    <app-icon icon="eye" />
                                </router-link>
                                <app-icon icon="trash" class="text-red cursor-pointer" @click="confirmModalOpened = true; confirmModalId = d.id" v-if="checkPermission('offers', 'delete')"/>
                            </app-table-cell>
                        </app-table-row>
                    </app-table-body>
                </app-table>
            </app-box>
        </app-content>

        <app-confirm-modal
            v-if="confirmModalOpened"
            @confirm="remove"
            @close="confirmModalOpened = false; confirmModalId = false"
            actionText="Yes please"
            cancelText="No thanks"
            heading="Hang on!"
            text="You are about to delete a offer. Are you sure you wish to continue?"
        />
    </app-main>
</template>

<script>
    import _ from 'lodash';
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import PaginationLinks from '@/components/PaginationLinks';
    import ConfirmModal from '@/components/modals/ConfirmModal';
    import TextField from '@/components/fields/inputs/Text';

    /* Mixins */
    import Query from '@/mixins/query';
    import Paginatable from '@/mixins/paginatable';
    import Permissions from '@/mixins/permissions';

    export default {
        name: 'offers.home',

        data: () => ({
            loading: true,
            offers: [],
            drafts: [],
            response: null,
            confirmModalOpened: false,
            confirmModalId: false,
            search: ''
        }),

        mixins: [ Query, Paginatable, Permissions ],

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-pagination-links': PaginationLinks,
            'app-confirm-modal': ConfirmModal,
            'app-field-text': TextField,
        },

        created() {
            if (this.$route.query.search && this.$route.query.search !== '') {
                this.search = this.$route.query.search;
            }
        },

        mounted() {
            this.getOffers()
                .then(response => {
                    return this.getDraftOffers();
                })
                .then(response => {
                    this.loading = false;
                });
        },

        methods: {
            searchOffers: _.debounce(function() {
                this.$route.query.page = '1';
                return this.getOffers();
            }, 500),

            resetSearch() {
                this.search = '';
                this.$route.query.search = '';
                this.$route.query.page = '1';
                this.getOffers();
            },

            getOffers() {
                let params = {};

                if (this.$route.query.page) {
                    params.page = this.$route.query.page;
                }

                if (this.search !== '') {
                    this.$route.query.search = this.search;
                    params.search = this.search;
                }

                return Api.request('get', `offers?${this.prepareGetQueryString(params)}`)
                    .then(({ data }) => {
                        this.offers = data.offers;
                        this.response = data;
                    });
            },

            getDraftOffers() {
                return Api.request('get', `offers/drafts`)
                    .then(({ data }) => {
                        this.drafts = data.offers;
                    });
            },

            remove() {
                this.confirmModalOpened = false;
                this.loading = true;

                this.deleteOffers( this.confirmModalId ).then(response => {
                    this.getOffers()
                        .then(response => {
                            return this.getDraftOffers();
                        })
                        .then(response => {
                            this.loading = false;
                            this.confirmModalId = false;
                        });
                });
            },

            deleteOffers(id) {
                return Api.request('get', `offers/delete/${id}`);
            },

            isTranslated(offer, locale) {
                let translated = false;

                if (offer.children.length > 0 && offer.locale.flag != locale.flag) {
                    offer.children.forEach(child => {
                        if (child.locale.flag == locale.flag) {
                            translated = true;
                        }
                    });
                }

                return translated;
            },

            getId(offer, locale) {
                let id = offer.id;

                if (offer.children.length > 0 && offer.locale.flag != locale.flag) {
                    offer.children.forEach(child => {
                        if (child.locale.flag == locale.flag) {
                            id = child.id;
                        }
                    });
                }

                return id;
            }
        },

        computed: {
            ...mapGetters({
                locales: 'locales/items'
            })
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/offers/Home.vue